import { createContext } from 'react'

const TodoListContext = createContext()

export default TodoListContext
